import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

import { getWordsAround } from "./utils";

type SearchPreviewProps = {
  preview: string;
  search: string;
};
export default function SearchPreview({ preview, search }: SearchPreviewProps) {
  const index = preview.toLowerCase().indexOf(search.toLowerCase());
  const { before, after } = getWordsAround(preview, index, 5, 5);

  const parts = [
    before + " ",
    after.substring(0, search.length),
    after.substring(search.length, after.length)
  ];

  return (
    <>
      {parts.map((part, index) => (
        <Typography
          key={index}
          component="span"
          variant="body1"
          sx={{
            background: index === 1 ? misc.warningYellow : undefined,
            lineHeight: 1.6
          }}
        >
          {part}
        </Typography>
      ))}
    </>
  );
}
